import {Document, Page, Text} from '@react-pdf/renderer';
import styles from '../styles';
import Header from './Header';
import Footer from './Footer';
import RiskSummaryVisualizationSection from './RiskSummaryVisualizationCard';
import ScoreFactorsSection from './ScoreFactorsSection';
import CoordinatesTableSection from './CoordinatesTableSection';
import CadastreReportsSection from './CadastreReportsSection';
import CultivationInfoCard from './CultivationInfoCard';
import {IRiskFactor, IUtmStandard} from '../types';
import {splitCoordinates, toPersianHectareText} from '../utils/formatData';
import {CULTIVATION_STATUS} from '../constants';

interface IFarmCreditReportPdfDocumentProps {
  serialNumber: string;
  riskGrade: string;
  riskGaugeScore: number;
  scoreFactorsData: IRiskFactor[];
  farms: IUtmStandard[];
}

export default function FarmCreditReportPdfDocument({
  serialNumber,
  riskGrade,
  riskGaugeScore,
  scoreFactorsData,
  farms,
}: IFarmCreditReportPdfDocumentProps) {
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <Header serialNumber={serialNumber} />
        <Text style={styles.pageTitle}>جزئیات اعتبارسنجی مزرعه</Text>

        <RiskSummaryVisualizationSection
          {...{
            riskGrade,
            riskGaugeScore,
          }}
        />

        <ScoreFactorsSection rows={scoreFactorsData.slice(0, 3)} />
        <ScoreFactorsSection rows={scoreFactorsData.slice(3, 6)} />

        {farms.map(farm => (
          <>
            <CadastreReportsSection
              farmName={farm.farm_name}
              ownerName={farm.farm_owner}
              cultivatedArea={toPersianHectareText(farm.cultivated_area)}
              farmArea={toPersianHectareText(farm.farm_area)}
              farmImage={farm.farm_image_url || ''}
            />
            <CoordinatesTableSection
              xData={splitCoordinates(farm.coordinates).xData.slice(0, 6)}
              yData={splitCoordinates(farm.coordinates).yData.slice(0, 6)}
              zData={Array(6).fill(farm.zone)}
            />

            {!!farm.cultivation_lend_utm_reports.length ? (
              <Text
                style={{
                  textAlign: 'right',
                  fontSize: 12,
                  fontWeight: 500,
                  marginTop: 20,
                  marginBottom: 10,
                  marginRight: 24,
                }}
              >
                جزئیات کشت‌های مزرعه
              </Text>
            ) : (
              <></>
            )}
            {farm.cultivation_lend_utm_reports?.map(report => (
              <CultivationInfoCard
                performanceUnit={report.performance_unit}
                name={report.name}
                cultivationArea={toPersianHectareText(report.area)}
                cultivationCase={CULTIVATION_STATUS[report.cultivation_status]}
                estimatedPerformance={report.performance_prediction?.toString()}
                estimatedPrice={
                  !!report.price_prediction
                    ? report.price_prediction.toString()
                    : ''
                }
                cultivationImage={report.cultivation_image_url || ''}
                album={report.ndvi_images.map(i => ({
                  imageUrl: i.thumbnail,
                  date: i.image_date,
                }))}
              />
            ))}
          </>
        ))}

        <Footer />
      </Page>
    </Document>
  );
}
